import LegalPolicy from "../LegalPolicy.tsx";

export default function CookiePolicyPage() {
	return <LegalPolicy id="59ab0152-3b8e-4c49-8064-8d6cce8be64e" />;
}
